import { render, staticRenderFns } from "./enquirytk.vue?vue&type=template&id=618cb878&scoped=true"
import script from "./enquirytk.vue?vue&type=script&lang=js"
export * from "./enquirytk.vue?vue&type=script&lang=js"
import style0 from "./enquirytk.vue?vue&type=style&index=0&id=618cb878&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618cb878",
  null
  
)

export default component.exports